
let projectsSwiper;
var init = false;

function enableSwiper(){
	projectsSwiper = new Swiper(".home-featured-projects.related-projects .swiper", {
		// Optional parameters
		loop: false,
		slidesPerView: 1,
		lazy: true,
		simulateTouch: false,

		autoplay: {
			delay: 5000,
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		},

		// If we need pagination
		pagination: false,

		// Navigation arrows
		navigation: {
			nextEl: ".home-featured-projects.related-projects .swiper .button-next",
			prevEl: ".home-featured-projects.related-projects .swiper .button-prev",
		},
	});
}


function swiperMode() {
	let mobile = window.matchMedia("(min-width: 0px) and (max-width: 767px)");
	let tablet = window.matchMedia("(min-width: 768px) and (max-width: 1399px)");
	let desktop = window.matchMedia("(min-width: 1400px)");

	// Enable (for mobile)
	if (mobile.matches) {
		if (!init) {
			enableSwiper();
			init = true;
		}
	}

	// Disable (for tablet)
	else if (tablet.matches) {
		if(init){
			projectsSwiper.destroy();
			init = false;
		}
	}

	// Disable (for desktop)
	else if (desktop.matches) {
		if(init){
			projectsSwiper.destroy();
			init = false;
		}
	}
}

window.addEventListener("load", function () {
	swiperMode();
});

window.addEventListener("resize", function () {
	swiperMode();
});


(function ($) {
	/**
	 * Load more related projects
	 */
	$('.loadmore-related-projects .btn').click(function(){
		var button = $(this),
			data = {
			'action': 'loadmore_related_projects',
			'team_member_id': $("#team_member_id").val(),
			'project_id': $("#project_id").val(),
		};

		$.ajax({
			url : loadmore_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text('Loading...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {
					button.text( 'Load More Projects' ); // insert new posts
					$(".related-projects .swiper-wrapper").append(data);
					$(".related-projects .swiper-wrapper").addClass('loaded');
					swiperMode();
					if(init){
						projectsSwiper.update();
						projectsSwiper.slideTo(3);
					}
				}
				button.remove(); // if no data, remove the button as well
			}
		});
	});

})(jQuery);
